/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'bookmark': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M31.5 12h-14c-.275 0-.5.225-.5.5v22.875c0 .274.28.353.475.158l7.086-6.283 6.908 6.172c.194.194.531.156.531-.297V12.5c0-.275-.225-.5-.5-.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/bookmark.js